import { CommonModule } from '@angular/common';
import { Component, inject, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AdService } from '../ad-service/ad-service';

@Component({
  selector: 'app-ad-form-submit',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule

  ],
  templateUrl: './ad-form-submit.dialog.html',
  styleUrl: './ad-form-submit.dialog.scss'
})
export class AdFormSubmitDialog {
  private adservice = inject(AdService);
  constructor(

    @Inject(MAT_DIALOG_DATA)
    public data: any

  ) { }

  private dialogRef =
    inject(MatDialogRef<AdFormSubmitDialog>);

  public confirmSubmit(): void {
    this.dialogRef.close({
      action: 'confirm'
    });
    // this.adservice.getdeclarationapproval()
    //   .then((response) => {
    //     console.log('Declaration approval data:', response);
    //   })
    //   .catch((error) => {
    //     console.error('Error fetching declaration approval data:', error);
    //   });
    //     this.dialogRef.close(true);

  }

  public cancel(): void {

    // console.log('Popup -> Cancel Clicked');

    this.dialogRef.close({
      action: 'cancel'
    });


  }
  getDisplayQuestionText(questionText: string): string {

    const questionMap: Record<string, string> = {
      MartialStatus: 'Marital Status',
      UserAddress: 'Residential Address',
      HouseNo: 'Home',
      Mobile: 'Mobile'
    };

    return questionMap[questionText] ?? questionText;
  }
  getFormattedSectionName(section: string): string {
    if (!section) return 'Declaration Review';

    const mapping: { [key: string]: string } = {
      'personalInfo': 'Personal Information',
      'spouseInfo': 'Spouse Information',
      'miscellaneous': 'Miscellaneous Details',
      'questionnaire1': 'Business Interests',
      'questionnaire2': 'General Information',
      'questionnaire3': 'Fit and Proper criteria',
      'questionnaire4': 'Tier1 and Tier 2 supervisor attestations',
    };

    return mapping[section] || section;
  }


}
